var exports = {
  "nA": "SectionContainer__4IHkUE",
  "nj": "TableContainerWithFooter__LvrXHh",
  "Gg": "TableFooter__lyK4a3",
};

module.exports = exports;
